// @core/api/endpoints/document/update_block.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  BlockResponse,
  UpdateBlockRequest,
} from '../../../types/document';

const BASE_PATH = '/document';

/**
 * Update block
 * Updates a block's content, properties, or type. Supports partial updates via field mask. Updates document.updated_at.
 */
export async function UpdateBlock(
  document_id: string,
  block_id: string,
  data: UpdateBlockRequest,
  options?: RequestOptions
): Promise<BlockResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/documents/:document_id/blocks/:block_id`;
  requestPath = requestPath.replace(':document_id', encodeURIComponent(document_id));
  requestPath = requestPath.replace(':block_id', encodeURIComponent(block_id));
  const requestOptions = options;
  return client.patch<BlockResponse>(requestPath, data, requestOptions);
}
